export default __webpack_public_path__ + "static/media/14-min.3e31c1f6.jpg";